import React from 'react';
import moment from 'moment';
import Field, { fieldTypes } from '../../../../../../shared/ui/Field';
import { fieldNames } from '../../../config';
import { getValidationRules } from './utils';

const PlanEndDateField = ({
  initialValue,
  form,
  fieldProps,
  editMode,
  shutdown,
}) => {
  const init = initialValue ? moment(initialValue) : null;

  return (
    <Field
      fieldType={fieldTypes.rangePicker}
      form={form}
      name={fieldNames.planEndDate}
      label="Дата завершения (план)"
      decoratorOptions={{
        rules: getValidationRules({
          initialValue: init,
          editMode,
          entity: editMode ? shutdown : form,
        }),
        initialValue: init,
      }}
      fieldProps={fieldProps}
    />
  );
};

export default PlanEndDateField;
